<template>
  <a-card title="订单管理">
    <div>
      <a-space>
        <p>订单号在支付宝、苹果收据邮件中均有体现</p>
        <a-input placeholder="苹果订单号" v-model:value="formSearch.order_no" />
        <a-button :loading="lookup_loading" type="primary" @click="handelLookupOrder()">查询苹果订单信息</a-button>
        <a-alert :message="'如果查不到，说明这笔订单有问题，不应该给用户退款，也不能当做购买成功'" type="warning" show-icon style="text-align: left;"  ></a-alert>
      </a-space>
    </div>
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input placeholder="订单 ID" v-model:value="formSearch.order_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="用户 ID" v-model:value="formSearch.user_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="交易 ID" v-model:value="formSearch.transaction_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="原始交易 ID" v-model:value="formSearch.origin_transaction_id" />
        </a-form-item>
        <a-form-item label="付款渠道">
          <a-select
            :allowClear="true"
            style="width:100px;"
            v-model:value="formSearch.payment_source"
            :options="payment_sources"
          />
        </a-form-item>
        <a-form-item label="交易状态">
          <a-select
            :allowClear="true"
            style="width:100px;"
            v-model:value="formSearch.trade_status"
            :options="trade_status"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
      <template #expandedRowRender="{ record }">
        <a-table
          :data-source="Object.entries(record).map(([key, value]) => ({ key, value: typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value) }))"
          :columns="[
            { title: '字段', dataIndex: 'key', key: 'key', width: 200 },
            { title: '值', dataIndex: 'value', key: 'value' }
          ]"
          :pagination="false"
          size="small"
          bordered
        />
      </template>
      <template #is_renew="{ record }">
        <a-tag v-if="record.is_renew" color="green">续费</a-tag>
        <a-tag v-else >新购</a-tag>
      </template>
      <template #transaction_id="{ record }" >
        <div v-if="record.transaction_id > ''">
          交易ID: {{ record.transaction_id }}
          原始交易ID: {{ record.origin_transaction_id }}
        </div>
        
      </template>
      <template #invoice_no="{ record }" >
        <div v-if="record.invoice_no > 0">
          <a-popover trigger="click">
            <template #content>
              发票号: {{ record.invoice_no }}
            </template>
            <a-tag color="green" style="cursor: pointer;">已开票</a-tag>
          </a-popover>
        </div>
        <div v-else >
          <a-button
            type="primary"
            size="small"
            @click="handleEditInvoiceNo(record)"
          >
            备注发票
          </a-button>
        </div>
      </template>
      <template #trade_status="{ record }">
        <a-tag v-if="record.trade_status === 'TRADE_SUCCESS'" color="green">交易成功</a-tag>
        <a-tag v-else-if="record.trade_status === 'TRADE_WAIT'" >待支付</a-tag>
        <a-tag v-else-if="record.trade_status === 'TRADE_FAILED'" color="red">支付失败</a-tag>
        <a-tag v-else-if="record.trade_status === 'TRADE_REFUND'" color="blue">已退款</a-tag>
        <a-tag v-else-if="record.trade_status === 'TRADE_TRANSFERRED'" color="orange">已转移</a-tag>
      </template>
      <template #created_at="{ record }">
       <div>创建时间: {{ record.created_at.toLocaleString() }}</div>
       <div>修改时间: {{ record.updated_at.toLocaleString() }}</div>
      </template>
      </a-table>
  </a-card>

  <a-modal v-model:open="lookup_order_open" title="苹果订单信息" @ok="lookup_order_open = false">
     <div>
      <a-tag color="red">transactionId: {{ lookup_order.transactionId }}</a-tag>
      <br/>
      <a-button
        type="primary"
        size="small"
        :disabled="!lookup_order.transactionId"
        @click="handleQueryByTransactionId"
      >
        点击根据交易ID查询这笔交易信息
      </a-button>
    </div>
    <div>
      <a-tag color="red">originalTransactionId: {{ lookup_order.originalTransactionId }}</a-tag>
      <br>
       <a-button
        type="primary"
        size="small"
        :disabled="!lookup_order.originalTransactionId"
        @click="handleQueryByOriginalTransactionId"
      >
        点击根据原始交易ID查询连续订阅的所有交易信息
      </a-button>
    </div>
    <pre>{{ lookup_order }}</pre>
    </a-modal>

  <a-modal v-model:open="invoice_no_open" title="备注发票" @ok="handleSaveInvoiceNo">
    <a-form layout="vertical">
      <a-form-item label="订单 ID">
        <a-input v-model:value="invoice_no_form.order_id" disabled />
      </a-form-item>
      <a-form-item label="发票编号">
        <a-input v-model:value="invoice_no_form.invoice_no" placeholder="请输入发票编号" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'


export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      payment_sources: [
        {
          label: "支付宝",
          value: "alipay",
        },
        {
          label: "微信",
          value: "wxpay",
        },
        {
          label: "苹果",
          value: "apple",
        },
        {
          label: "谷歌",
          value: "google",
        },{
          label: "PayPal",
          value: "paypal",
        }
    ],
      trade_status: [{
        label: "交易成功",
        value: "TRADE_SUCCESS"
      },{
        label: "待支付",
        value: "TRADE_WAIT"
      },{
        label: "支付失败",
        value: "TRADE_FAILED"
      },{
        label: "已退款",
        value: "TRADE_REFUND"
      }],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      lookup_order_open: false,
      lookup_loading: false,
      lookup_order: {},
      invoice_no_open: false,
      invoice_no_form: {
        order_id: '',
        invoice_no: '',
      },
       formSearch: {
        user_id: '',
        order_no: '',
        transaction_id: '',
        origin_transaction_id: '',
        order_id: '',
        trade_status: '',
        payment_source: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  computed:{},
  methods: {
    handleEditInvoiceNo(record){
      this.invoice_no_form.order_id = record.order_id
      this.invoice_no_form.invoice_no = ''
      this.invoice_no_open = true
    },
    async handleSaveInvoiceNo(){
      if (!this.invoice_no_form.invoice_no) {
        return
      }
      await request.put('/api/orders/invoice_no', {
        order_id: this.invoice_no_form.order_id,
        invoice_no: this.invoice_no_form.invoice_no,
      }, '备注发票成功')
      this.invoice_no_open = false
      this.handleTableChange({ pageSize: this.pagination.pageSize, current: this.pagination.current })
    },
    handleQueryByOriginalTransactionId(){
      this.formSearch.origin_transaction_id = this.lookup_order.originalTransactionId
      this.lookup_order_open = false
      this.handleTableChange()
    },
    handleQueryByTransactionId(){
      this.formSearch.transaction_id = this.lookup_order.transactionId
      this.lookup_order_open = false
      this.handleTableChange()
    },
    handelLookupOrder(){
      this.lookup_loading = true
      request.get('/api/orders/lookup_no', {
        ...this.formSearch
      }).then(resp => {
        if (resp.code != 0) {
          this.lookup_order = {
            "message": resp.message,
            "transactionId": "",
          }
        } else {
          this.lookup_order = resp.data 
        }
      }).catch(err => {
        this.lookup_order = {
          "message": err.message,
          "transactionId": "",
        }
      }).finally(() => {
        this.lookup_loading = false
        this.lookup_order_open = true
      })
  
      
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/orders/search', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      for (let item of rsp.data.list) {
        item.created_at = new Date(item.created_at)
        item.updated_at = new Date(item.updated_at)
      }
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
        {
          title: '订单 ID',
          dataIndex: 'order_id',
          key: 'order_id',
        },
        {
          title: '用户 ID',
          key: 'user_id',
          dataIndex: 'user_id',
        },
        {
          title: '用户昵称',
          key: 'nickname',
          dataIndex: 'nickname',
        },
        {
          title: '商品 ID',
          dataIndex: 'vip_meal_id',
          key: 'vip_meal_id',
        },
        {
          title: '商品名称',
          key: 'vip_meal_name',
          dataIndex: 'vip_meal_name',
        },
        {
          title: '支付金额',
          dataIndex: 'pay_amount',
          key: 'pay_amount',
        },
        {
          title: '货币',
          dataIndex: 'currency',
          key: 'currency',
        },
        {
          title: '支付时间',
          dataIndex: 'pay_time',
          key: 'pay_time',
        },
        {
          title: '支付状态',
          dataIndex: 'trade_status',
          key: 'trade_status',
          slots: { customRender: 'trade_status' },
        },
        {
          title: '交易 ID',
          dataIndex: 'transaction_id',
          key: 'transaction_id',
          slots: { customRender: 'transaction_id' },
        },
        {
          title: '支付渠道',
          dataIndex: 'payment_source',
          key: 'payment_source',
        },
        {
          title: '是否续费',
          dataIndex: 'is_renew',
          key: 'is_renew',
          slots: { customRender: 'is_renew' },

        },{
          title: '发票信息',
          dataIndex: 'invoice_no',
          key: 'invoice_no',
          slots: { customRender: 'invoice_no' },

        },
        {
          title: '备注',
          dataIndex: 'mark',
          key: 'mark',

        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'created_at' },

        },
        
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>